import { useCallback, useEffect, useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import { SettingEnum } from 'constants/setting'
import { logError } from 'utils/logger'

export const useAppSetting = () => {
  const [setting, setSetting] = useState<any | null>(null)

  useEffect(() => {
    handleGetSetting()
  }, [])

  const handleGetSetting = async () => {
    try {
      const results = await AppAdmin.getListContractInfo()
      if (results.status === 200) {
        setSetting(results.data.data)
      }
    } catch (error) {
      logError(error)
    }
  }

  const getSetting = useCallback(
    (key: SettingEnum) => {
      if (!setting) return null
      return setting[key] || null
    },
    [setting]
  )

  return {
    setting,
    getSetting,
  }
}
